import Types from './Types';

const INITIAL_STATE = {
    assistants: [],
    assistant: {},
    isLoading: false,
    count: ''
};

export default function assistants(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_ALL_ASSISTANTS_SUCCESS: {
            const assistantsData = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
            return {
                ...state,
                assistants: assistantsData,
                count: assistantsData.length
            };
        }

        case Types.EDIT_ASSISTANT_SUCCESS: {
            let data = payload.data;
            if (!data || !data.id) {
                return state;
            }
            const assistants = [...state.assistants];
            let idx = -1;
            assistants.forEach((item, index) => {
                if (item.id === data.id) {
                    idx = index;
                    return;
                }
            });

            if (idx >= 0) {
                assistants[idx] = data;
            }
            return {
                ...state,
                assistants: assistants
            };
        }

        case Types.CREATE_ASSISTANT_SUCCESS: {
            const data = payload.data.data || payload.data;
            let newArray = state.assistants.slice();
            newArray.push(data);
            return {
                ...state,
                assistants: newArray
            };
        }
        case Types.ADD_ASSISTANTS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.DELETE_ASSISTANT_SUCCESS: {
            const newAssistants = state.assistants.filter((item) => item.id !== payload);
            return {
                ...state,
                assistants: newAssistants
            };
        }

        case Types.SUSPEND_ASSISTANT_SUCCESS: {
            let id = payload.payload;
            // Handle different response structures
            let data = payload.result?.data?.data || payload.result?.data || payload.result;
            
            const assistants = state.assistants || [];
            let idx = -1;
            assistants.forEach((item, index) => {
                if (item.id === id) {
                    idx = index;
                    return;
                }
            });
            if (idx !== -1 && assistants[idx]) {
                // Update deleted_at if provided, otherwise toggle it
                if (data && data.deleted_at !== undefined) {
                    assistants[idx].deleted_at = data.deleted_at;
                } else {
                    // Toggle deleted_at if not provided in response
                    assistants[idx].deleted_at = assistants[idx].deleted_at ? null : new Date().toISOString();
                }
            }
            
            return {
                ...state,
                assistants: [...assistants],
            };
        }

        default: {
            return state;
        }
    }
}

